@if(isImageType() && imageUrl() && !imageLoadError()) {
<img [src]="imageUrl() || ''" alt="File preview" class="file-preview" [style.width.px]="getIconSizePx() * 20 / 24"
    [style.height.px]="getIconSizePx()" (error)="onImageError()" />
} @else {
<app-icon [type]="getSvgWithSize()" [source]="'svg'" [size]="namedSize()" class="!h-full !w-full"></app-icon>
}
